import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static values = {
    videoId: String,
    videoPrefix: String,
  };

  player;

  connect() {
    if (window.YT) {
      this.init();
    }
  }

  initialize() {
    this.load();
  }

  load() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
  }

  init() {
    this.player = new window.YT.Player(`${this.videoPrefixValue}-${this.videoIdValue}`, {
      height: '640',
      width: '1112',
      videoId: this.videoIdValue,
    });
  }
}
